module.exports = "/images/sr.svg?2199d3b601636756c6b77908e8b4b461";